import Slider from 'react-slick'
import closeBtn from '../../Assets/img/close.png'
import leftArrow from '../../Assets/Bisoft_UI/Buttons/Active without shadow/left-arrow.png'
import rightArrow from '../../Assets/Bisoft_UI/Buttons/Active without shadow/right-arrow.png'
import renderPrgImage from '../../source/programImg'

function SampleNextArrow(props) {
    const { className, onClick } = props
    var style = {
        fontSize: '0',
        lineHeight: '0',
        position: 'absolute',
        top: '55%',
        display: 'block',
        padding: '0 0 0 32px',
        transform: 'translate(-50%, -50%)',
        cursor: 'pointer',
        color: 'transparent',
        border: 'none',
        outline: 'none',
        background: 'transparent',
    }
    return (
        <div>
            <div
                className={'slick-arrow'}
                style={{
                    ...style,
                    // right: "-290px",
                    // height: '25%',
                    zIndex: '1000',
                    // right: '-17%',
                    left: '100%',
                    width: '25%',
                    cursor: 'default',
                }}
            >
                <img
                    src={rightArrow}
                    style={{ width: '30%', cursor: 'grab' }}
                    onClick={onClick}
                ></img>
            </div>
        </div>
    )
}

function SamplePrevArrow(props) {
    const { className, onClick } = props
    var style = {
        fontSize: '0',
        lineHeight: '0',
        position: 'absolute',
        top: '55%',
        display: 'block',
        padding: '0',
        transform: 'translate(-50%, -50%)',
        cursor: 'pointer',
        color: 'transparent',
        border: 'none',
        outline: 'none',
        background: 'transparent',
    }
    return (
        <div
            className={'slick-arrow'}
            style={{
                ...style,
                left: '16%',
                display: 'block',
                width: '25%',
                zIndex: '1000',
                cursor: 'default',
            }}
        >
            <img
                src={leftArrow}
                style={{ width: '30%', cursor: 'grab', zIndex: '1000' }}
                onClick={onClick}
            ></img>
        </div>
    )
}

var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
}

function SpeechHelpOverlay({ onClose }) {
    return (
        <div
            style={{
                height: '100vh',
                width: '100vw',
                background: '#fff',
                position: 'relative',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)',
                zIndex: '100000',
                position: 'absolute',
            }}
        >
            <div
                onClick={onClose}
                style={{
                    borderRadius: '50%',
                    zIndex: '2000',
                    position: 'absolute',
                    top: '15%',
                    right: '18%',
                }}
            >
                <img
                    src={closeBtn}
                    style={{ width: '7vh', height: 'auto' }}
                />
            </div>
            <Slider
                {...settings}
                style={{
                    transform: 'translate(-50%,-50%)',
                    top: '46%',
                    left: '50%',
                    zIndex: '10',
                    position: 'absolute',
                }}
            >
                <div
                    style={{
                        height: '100%',
                        width: '100%',
                        background: '#fff',
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        zIndex: '1000',
                    }}
                >
                    <img
                        src={renderPrgImage('emotionDecH')}
                        style={{ width: '100%' }}
                    />
                    <div
                        style={{
                            zIndex: '2000',
                            position: 'absolute',
                            top: '54%',
                            left: '25.4%',
                            transform: 'translate(-50%,-50%)',
                            width: '2%',
                        }}
                    >
                        <p
                            style={{
                                backgroundColor: 'white',
                                padding: '4px',
                                fontSize: '1.8vh',
                                textAlign: 'left',
                                color: '#707070',
                                fontFamily: 'Halcyon_Regular',
                                borderRadius: '12px',
                                marginBottom: '0px',
                            }}
                        >
                            Camera scene is the output window of what
                            the web camera will see & detect
                        </p>
                    </div>
                </div>

                {/* <div
                    style={{
                        height: '100%',
                        width: '100%',
                        background: '#fff',
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        zIndex: '1000',
                    }}
                >
                    <img
                        src={renderPrgImage('emotionDecH1')}
                        style={{ width: '100%' }}
                    />
                    <div
                        style={{
                            zIndex: '2000',
                            position: 'absolute',
                            top: '41.5%',
                            left: '23.5%',
                            transform: 'translate(-50%,-50%)',
                            width: '1.5%',
                        }}
                    >
                        <p
                            style={{
                                backgroundColor: 'white',
                                padding: '4px',
                                fontSize: '1.8vh',
                                textAlign: 'left',
                                color: '#707070',
                                fontFamily: 'Halcyon_Regular',
                                borderRadius: '12px',
                                marginBottom: '0px',
                            }}
                        >
                            Message & values display screen show the
                            message or values as an output for the
                            program that is running
                        </p>
                    </div>
                </div> */}

                {/* <div
                    style={{
                        height: '100%',
                        width: '100%',
                        background: '#fff',
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        zIndex: '1000',
                    }}
                >
                    <img
                        src={renderPrgImage('emotionDecH2')}
                        style={{ width: '100%' }}
                    />
                    <div
                        style={{
                            zIndex: '2000',
                            position: 'absolute',
                            top: '60.5%',
                            left: '30.7%',
                            transform: 'translate(-50%,-50%)',
                            width: '1.5%',
                        }}
                    >
                        <p
                            style={{
                                backgroundColor: 'white',
                                padding: '4px',
                                fontSize: '1.8vh',
                                textAlign: 'left',
                                color: '#707070',
                                fontFamily: 'Halcyon_Regular',
                                borderRadius: '12px',
                                marginBottom: '0px',
                            }}
                        >
                            Message & values display screen show the
                            message or values as an output for the
                            program that is running
                        </p>
                    </div>
                </div> */}

                <div
                    style={{
                        height: '100%',
                        width: '100%',
                        background: '#fff',
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        zIndex: '1000',
                    }}
                >
                    <img
                        src={renderPrgImage('emotionDecH3')}
                        style={{ width: '100%' }}
                    />
                    <div
                        style={{
                            zIndex: '2000',
                            position: 'absolute',
                            top: '55%',
                            left: '34.8%',
                            transform: 'translate(-50%,-50%)',
                            width: '2%',
                        }}
                    >
                        <p
                            style={{
                                backgroundColor: 'white',
                                padding: '4px',
                                fontSize: '1.8vh',
                                textAlign: 'left',
                                color: '#707070',
                                fontFamily: 'Halcyon_Regular',
                                borderRadius: '12px',
                                marginBottom: '0px',
                            }}
                        >
                            The image/video output space, shows the
                            images if any of the if condition is true
                        </p>
                    </div>
                </div>

                <div
                    style={{
                        height: '100%',
                        width: '100%',
                        background: '#fff',
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        zIndex: '1000',
                    }}
                >
                    <img
                        src={renderPrgImage('emotionDecH4')}
                        style={{ width: '100%' }}
                    />
                    <div
                        style={{
                            zIndex: '2000',
                            position: 'absolute',
                            top: '78%',
                            left: '46.6%',
                            transform: 'translate(-50%,-50%)',
                            width: '2%',
                        }}
                    >
                        <p
                            style={{
                                backgroundColor: 'white',
                                padding: '4px',
                                fontSize: '1.8vh',
                                textAlign: 'left',
                                color: '#707070',
                                fontFamily: 'Halcyon_Regular',
                                borderRadius: '12px',
                                marginBottom: '0px',
                            }}
                        >
                            Click on this button to run the app mode.
                            The respective action will be executed, when
                            the if condition is true
                        </p>
                    </div>
                </div>

                <div
                    style={{
                        height: '100%',
                        width: '100%',
                        background: '#fff',
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        zIndex: '1000',
                    }}
                >
                    <img
                        src={renderPrgImage('emotionDecH5')}
                        style={{ width: '100%' }}
                    />
                    <div
                        style={{
                            zIndex: '2000',
                            position: 'absolute',
                            top: '78%',
                            left: '56.6%',
                            transform: 'translate(-50%,-50%)',
                            width: '2%',
                        }}
                    >
                        <p
                            style={{
                                backgroundColor: 'white',
                                padding: '4px',
                                fontSize: '1.8vh',
                                textAlign: 'left',
                                color: '#707070',
                                fontFamily: 'Halcyon_Regular',
                                borderRadius: '12px',
                                marginBottom: '0px',
                            }}
                        >
                            Click on this button to stop the app mode
                            code execution
                        </p>
                    </div>
                </div>
            </Slider>
        </div>
    )
}

export default SpeechHelpOverlay
